/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { scrollToAnchor } from "../../../../theme/commonStyle";
import greenCircle from "../../../../assets/img/generic/circle_green_100px.png";
import redCircle from "../../../../assets/img/generic/circle_red_100px.png";
import { Theme } from "@mui/material";

const trafficCostRiskSectionStyle = {
  noWinNoFeeSection: {
    textAlign: "center",
  },
  paragraph: {
    marginTop: 0,
  },
  paragraphTop: {
    margin: "auto",
    maxWidth: "700px",
  },
  box: {
    margin: "auto",
    maxWidth: 700,
    borderRadius: "7px",
    border: "1px solid lightgrey",
    height: "100%",
    padding: "0 2rem 1rem 2rem",
  },
  subHeadlineFirst: {
    fontWeight: 500,
    paddingTop: "2rem",
  },
  subHeadlineSecond: {
    fontWeight: 500,
    paddingTop: "2rem",
    paddingBottom: "1rem",
  },
  subHeadlineThird: (theme: Theme) => ({
    fontWeight: 500,
    ...(theme.palette.mode !== "dark"
      ? {
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundImage: `url(${greenCircle})`,
        }
      : {}),
    maxWidth: 250,
    margin: "0 auto",
    paddingTop: "3rem",
    paddingBottom: "3rem",
  }),
  subHeadlineForth: (theme: Theme) => ({
    fontWeight: 500,
    ...(theme.palette.mode !== "dark"
      ? {
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundImage: `url(${redCircle})`,
        }
      : {}),
    maxWidth: 250,
    margin: "0 auto",
    paddingTop: "3rem",
    paddingBottom: "3rem",
  }),
  costsSecureIcon: {
    marginTop: "2rem",
    width: "150px",
    height: "auto",
  },
  scrollToAnchor,
};

export default trafficCostRiskSectionStyle;
